import React from "react";
import {FormattedMessage} from "react-intl";
import {connect} from "react-redux";
import {handleBackToDashboard} from "./backToDashboard";
import {isIframe} from "../../../misc/helpers";
import {IS_LIXIL_SERVERS} from "../../../config";


const BackToDashboardButton = (props) => {

  const {isEncore} = props;

  if (window.salesForceLoaded || window.sr || !isIframe() || isEncore || IS_LIXIL_SERVERS) {
    return null
  }

  return (
    <button className="ui-button ui-button--blue ui-button--back-to-dashboard-close"
            onClick={handleBackToDashboard}>
      <span className="ui-button-text"><FormattedMessage id="dashboardButtons.back"/></span>
    </button>
  )
};

const mapStateToProps = (store) => {
  const {isEncore} = store.fabricatorState;
  return {
    isEncore,
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(BackToDashboardButton)
